import { useNavigate } from 'react-router';

import { useIssueReportGuideModal } from '@/hook';
import { ArrowForward, Mail, VButton, VFlex, VStack } from '@/package';

const HelpPageContent = () => {
  const { openModal, Modal } = useIssueReportGuideModal();
  const navigate = useNavigate();

  return (
    <>
      <VStack className="py-16" gap={4}>
        <VFlex className="w-full" justify="center">
          <VStack items="center" gap={1}>
            <div className="text-headline-xl font-semibold">
              How can we help?
            </div>
            <div className="text-center text-headline-sm whitespace-pre-line">
              {`We provide guides on schema structure and keyboard shortcuts to help you use VueX more efficiently. 
More detailed FAQs will be added soon. 
If you have any further questions, feel free to reach out.`}
            </div>
            <VButton outlined size="sm" variant="secondary" onClick={openModal}>
              <VFlex gap={0.25} items="center">
                <Mail className="size-4" />
                <span>support@vueron.com</span>
              </VFlex>
            </VButton>
          </VStack>
        </VFlex>

        <VFlex className="w-full" justify="center">
          <VFlex items="center" gap={1}>
            <VFlex
              className="h-[124px] w-[464px] rounded-md bg-gradient-to-br from-slate-900 via-slate-800 to-blue-600 p-2 font-semibold text-white"
              items="center"
              justify="center"
              gap={0.25}
              role="button"
              onClick={() => {
                navigate('/help/mouse-keyboard');
              }}
            >
              Mouse & Keyboard guide
              <ArrowForward className="size-6" />
            </VFlex>
            <VFlex
              className="h-[124px] w-[464px] rounded-md bg-gradient-to-br from-slate-900 via-slate-800 to-blue-600 p-2 font-semibold text-white"
              items="center"
              justify="center"
              gap={0.25}
              role="button"
              onClick={() => {
                navigate('/help/schema');
              }}
            >
              Schema structure guide
              <ArrowForward className="size-6" />
            </VFlex>
          </VFlex>
        </VFlex>
      </VStack>

      <Modal />
    </>
  );
};

export default HelpPageContent;
